import { Controller } from '@hotwired/stimulus';

/**
 * Auto-submits the Gillamoos calendar filter form when a dropdown (Standort,
 * Tag) changes — the text search still waits for the explicit "Suchen" button.
 *
 * Attach to the <form> as data-controller="gillamoos-calendar" and wire each
 * select with data-action="change->gillamoos-calendar#submit".
 */
export default class extends Controller {
    submit() {
        if (typeof this.element.requestSubmit === 'function') {
            this.element.requestSubmit();
        } else {
            this.element.submit();
        }
    }
}
